import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "working-with-react"
    }}>{`Working with React`}</h1>
    <p>{`When working with React, other frameworks, or bundlers like Webpack and Parcel, you'll need to understand how to effectively use them inside the developer tool. There are various options available to you, depending on your workflow needs.`}</p>
    <h2 {...{
      "id": "adding-a-plugin-to-the-workspace"
    }}>{`Adding a plugin to the workspace`}</h2>
    <p>{`In this particular scenario, you'll essentially have `}<em parentName="p">{`two`}</em>{` `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` files. One will be in your plugin's source code directory, and the other will be in your plugin's distribution directory.`}</p>
    <p>{`You can load either one of these, but you need to be aware of the differences.`}</p>
    <ul>
      <li parentName="ul">{`Adding a plugin using the distribution `}<inlineCode parentName="li">{`manifest.json`}</inlineCode>{` means that you're loading the plugin from the distribution folder entirely. If your plugin build steps involve removing and recreating the distribution folder, or cleaning all the files within the folder, your plugin may not reload correctly in the developer tool.`}</li>
      <li parentName="ul">{`Adding a plugin using the source `}<inlineCode parentName="li">{`manifest.json`}</inlineCode>{` is the preferred option, but you'll also need to edit the plugin's options. Open `}<strong parentName="li">{`••• > Options`}</strong>{`, click `}<strong parentName="li">{`Advanced`}</strong>{`, and then enter the `}<em parentName="li">{`relative`}</em>{` path (from the `}<inlineCode parentName="li">{`manifest.json`}</inlineCode>{` file you selected) to your plugin's distribution folder. This will load the plugin in the same manner as the previous point, but any build steps that remove or recreate the distribution folder won't impact reloading the plugin in the developer tool.`}</li>
    </ul>
    <p>{`Another important note is that if you're adding a plugin that uses a bundler or framework make sure you install its dependencies – for example, if you're downloading the sample plugins for Photoshop, you'll need to run `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` or `}<inlineCode parentName="p">{`yarn install`}</inlineCode>{` for those based on React. The Developer Tool will not do this for you.`}</p>
    <h2 {...{
      "id": "watching-your-plugin"
    }}>{`Watching your plugin`}</h2>
    <p>{`When using bundlers or frameworks, you'll typically have a build step that watches your plugins for changes. The developer tool does not know about your build steps, so if you want the developer tool to reload automatically when changes are detected, you'll need to:`}</p>
    <ul>
      <li parentName="ul">{`Run your `}<inlineCode parentName="li">{`watch`}</inlineCode>{` build process in a terminal`}</li>
      <li parentName="ul"><strong parentName="li">{`••• > Watch`}</strong>{` the desired plugin from the Developer Tool`}</li>
    </ul>
    <p>{`When your `}<inlineCode parentName="p">{`watch`}</inlineCode>{` build process detects a change, it'll rebuild the plugin, and this will cause the Developer Tool to see the resulting build changes and reload the plugin in the host.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      